import React from 'react';

import scss from './WithToolbarWrapper.module.scss';

function WithToolbarWrapper({ children }) {
  return <div className={scss.wrapper}>{children}</div>;
}

export default WithToolbarWrapper;
